export const header = `w-full flex items-center mb-4 gap-4 flex-row-reverse md:flex-row`;
export const radiusSelector = `absolute top-8 left-8`;
